import { is8DataApp, pathname } from '../../utils';

const initNavItems = [
  {
    passiveLogo: 'sidebar/dashboard/dashboardPassive.svg',
    hoverLogo: 'sidebar/dashboard/dashboardHover.svg',
    activeLogo: 'sidebar/dashboard/dashboardActive.svg',
    href: pathname.dashboard.url,
    text: 'Demand Console',
    hover: false,
    active: null,
  },
  {
    passiveLogo: 'sidebar/lines/linesLabPassive.svg',
    hoverLogo: 'sidebar/lines/linesLabHover.svg',
    activeLogo: 'sidebar/lines/linesLabActive.svg',
    href: pathname.lines.url,
    text: pathname.lines.label,
    hover: false,
    active: null,
  },
  {
    passiveLogo: 'sidebar/remittance/remittancePassive.svg',
    hoverLogo: 'sidebar/remittance/remittanceHover.svg',
    activeLogo: 'sidebar/remittance/remittanceActive.svg',
    href: pathname.remittance.url,
    text: pathname.remittance.label,
    hover: false,
    active: null,
  },
  {
    passiveLogo: 'sidebar/plans/plansPassive.svg',
    hoverLogo: 'sidebar/plans/plansHover.svg',
    activeLogo: 'sidebar/plans/plansActive.svg',
    href: pathname.plans.url,
    text: 'Plans',
    hover: false,
    active: null,
  },
  {
    passiveLogo: 'sidebar/account/accountPassive.svg',
    hoverLogo: 'sidebar/account/accountHover.svg',
    activeLogo: 'sidebar/account/accountActive.svg',
    href: pathname.account.main.url,
    text: 'Account',
    hover: false,
    active: null,
  },
];

const initNavItems8Data = [
  {
    passiveLogo: 'sidebar/8data/dashboard/dashboardPassive.svg',
    hoverLogo: 'sidebar/8data/dashboard/dashboardHover.svg',
    activeLogo: 'sidebar/8data/dashboard/dashboardActive.svg',
    href: pathname.dashboard.url,
    text: 'Demand Console',
    hover: false,
    active: null,
  },
  {
    passiveLogo: 'sidebar/8data/lines/linesLabPassive.svg',
    hoverLogo: 'sidebar/8data/lines/linesLabHover.svg',
    activeLogo: 'sidebar/8data/lines/linesLabActive.svg',
    href: pathname.lines.url,
    text: pathname.lines.label,
    hover: false,
    active: null,
  },
  {
    passiveLogo: 'sidebar/8data/account/accountPassive.svg',
    hoverLogo: 'sidebar/8data/account/accountHover.svg',
    activeLogo: 'sidebar/8data/account/accountActive.svg',
    href: pathname.account.main.url,
    text: 'Account',
    hover: false,
    active: null,
  },
];

const initNavItemsDifferentBehavior = [
  {
    passiveLogo: 'sidebar/support/supportPassive.svg',
    hoverLogo: 'sidebar/support/supportHover.svg',
    activeLogo: 'sidebar/support/supportActive.svg',
    href: '',
    text: 'Support',
    hover: false,
    active: null,
  },
  {
    passiveLogo: 'sidebar/singout/singoutPassive.svg',
    hoverLogo: 'sidebar/singout/singoutHover.svg',
    activeLogo: 'sidebar/singout/singoutActive.svg',
    href: 'null',
    text: 'Sign out',
    hover: false,
    active: null,
  },
];

const initNavItemsDifferentBehavior8Data = [
  {
    passiveLogo: 'sidebar/8data/support/supportPassive.svg',
    hoverLogo: 'sidebar/8data/support/supportHover.svg',
    activeLogo: 'sidebar/8data/support/supportActive.svg',
    href: '',
    text: 'Support',
    hover: false,
    active: null,
  },
  {
    passiveLogo: 'sidebar/8data/singout/singoutPassive.svg',
    hoverLogo: 'sidebar/8data/singout/singoutHover.svg',
    activeLogo: 'sidebar/8data/singout/singoutActive.svg',
    href: 'null',
    text: 'Sign out',
    hover: false,
    active: null,
  },
];

export function getInitNavItems(path) {
  const items = is8DataApp() ? initNavItems8Data : initNavItems;
  return items.map((item) => {
    item.active = path === item.href;
    return item;
  });
}

export function getInitNavItemsOther() {
  return is8DataApp()
    ? initNavItemsDifferentBehavior8Data
    : initNavItemsDifferentBehavior;
}
